import {SellerError} from './SellerError.js'

export class SaveInstantOfferDraftFromAPISellerError extends SellerError {
  constructor(message) {
    super(message)
    this.name = 'SaveInstantOfferDraftFromAPISellerError'
  }
}
